export default __webpack_public_path__ + "static/media/027-koala.577acc0f.svg";